export type ConfigurationView = 'Templates' | 'Agents' | 'Skills' | 'Teams' | 'GitHub Apps' | 'Environments' | 'Jobs';

export type NavGroup = {
  label: string;
  items: ConfigurationView[];
};

export const navGroups: NavGroup[] = [
  { label: 'Configuration', items: ['Templates', 'Agents', 'Skills', 'Teams', 'GitHub Apps', 'Environments'] },
  { label: 'Management', items: ['Jobs'] },
];

export const configurationItems: ConfigurationView[] = navGroups.flatMap(group => group.items);

export function getNavGroupLabel(view: ConfigurationView): string {
  return navGroups.find(group => group.items.includes(view))?.label ?? 'Configuration';
}
